<template>
  <v-tooltip
    top
    content-class="tooltip-top ism-truncated-tooltip"
    open-delay="200"
    :nudge-top="4"
    :disabled="!isTruncated"
  >
    <template v-slot:activator="{ on, attrs }">
      <span
        ref="cell"
        class="ism-truncated-cell"
        :style="{ maxWidth: maxWidth }"
        v-bind="attrs"
        v-on="on"
      >{{ text }}</span>
    </template>
    <span>{{ text }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'TruncatedCell',

  props: {
    text:     { type: String,  default: '' },
    maxWidth: { type: String,  default: '220px' },
  },

  data() {
    return { isTruncated: false };
  },

  mounted() {
    this.$nextTick(this.checkTruncation);
  },

  updated() {
    this.$nextTick(this.checkTruncation);
  },

  methods: {
    checkTruncation() {
      const el = this.$refs.cell;
      if (el) {
        this.isTruncated = el.scrollWidth > el.clientWidth;
      }
    },
  },

  watch: {
    text() {
      this.$nextTick(this.checkTruncation);
    },
  },
};
</script>

<style scoped>
.ism-truncated-cell {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  cursor: default;
  font-size: 13.5px;
  color: var(--text-primary, #1e293b);
}
</style>

<style>
/* Wider tooltip for long text — non-scoped so it applies to body-appended tooltip */
.ism-truncated-tooltip {
  max-width: 360px !important;
  white-space: normal !important;
  line-height: 1.5 !important;
  word-break: break-word !important;
}
</style>
